export const AppSettingKey = {
  WORKDAY_CONFIGURATION: 'WORKDAY_CONFIGURATION',
}
